import { useState } from 'react'

import type { OpenFilePickerConfigType } from './config'
import { config, defaultFilePickerConfig } from './config'
import type { GetFilesFromPickerFunction } from './types'

export const useOpenFilePicker = (): [
  File[],
  OpenFilePickerConfigType | undefined,
  GetFilesFromPickerFunction,
] => {
  const [files, setFiles] = useState<{
    files: File[]
    options: OpenFilePickerConfigType | undefined
  }>({ files: [], options: undefined })

  const getFilesFromExplorer: GetFilesFromPickerFunction = async options => {
    const files: FileSystemFileHandle[] = await window.showOpenFilePicker(
      options ? config[options] : defaultFilePickerConfig,
    )
    const newFiles = await Promise.all([...files.map(file => file.getFile())])
    setFiles({ files: newFiles, options })
  }

  return [files.files, files.options, getFilesFromExplorer]
}
